import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const DocumentValidator = z.literal('document');
export type TDocumentValidator = z.infer<typeof DocumentValidator>;

export const DocumentValidatorParamsSchema = z.record(z.string(), z.unknown());

export type TDocumentValidatorParams = z.infer<typeof DocumentValidatorParamsSchema>;

export const DocumentValidatorSchema = BaseValidatorSchema.extend({
  type: DocumentValidator,
  value: DocumentValidatorParamsSchema.optional(),
});
